import './RobHippieScene.css';

const qty = (value) => Number(value || 0).toFixed(1).replace(/\.0$/, '');

function RobButton({ children, detail, disabled, onClick, tone = '' }) {
  return (
    <button className={`rob-choice ${tone}`.trim()} disabled={disabled} onClick={onClick}>
      <strong>{children}</strong>
      {detail && <small>{detail}</small>}
    </button>
  );
}

export function RobHippieScene({ gameState, busy, actions }) {
  const rob = gameState.robTheHippiePublic || {};
  const effect = rob.stonedEffect || null;
  const rips = Math.max(0, Number(rob.sessionRips || 0));
  const giftChance = Math.round(Math.max(0, Number(rob.giftChance || 0)) * 100);
  const active = Boolean(rob.sessionActive);

  return (
    <div className="rob-overlay" role="dialog" aria-modal="true" aria-labelledby="rob-title">
      <div className="rob-frame">
        <div className="rob-art-wrap">
          <img className="rob-art" src="./scenes/rob_the_hippie_scene.webp" alt="Rob the Hippie relaxing on a stained couch with his lazy cat in his Mt. Gate trailer" />
          <div className="rob-art-shade" aria-hidden="true" />
          <div className="rob-label">MT. GATE · ROB'S TRAILER</div>
          {effect && <div className="rob-stoned-badge">WAY TOO STONED · {effect.tripsRemaining} TRIP{Number(effect.tripsRemaining) === 1 ? '' : 'S'} LEFT</div>}
        </div>
        <div className="rob-lower">
          <section className="rob-copy">
            <span className="scene-kicker">GOOD VIBES · QUESTIONABLE DIRECTIONS</span>
            <h2 id="rob-title">Rob the Hippie</h2>
            <p>Rob waves you toward the couch, nudges the bong across the coffee table, and tells you to relax. His cat does not move because the cat has transcended movement.</p>
            <blockquote>“Sit down, man. Nobody ever solved anything by being less stoned.”</blockquote>
            <div className="rob-facts">
              <span><b>{rips}</b><small>Bong rip{rips === 1 ? '' : 's'} this session</small></span>
              <span><b>{rob.giftedToday ? 'GIFTED' : `${giftChance}%`}</b><small>{rob.giftedToday ? 'Rob already hooked you up today' : 'Current weed-gift chance'}</small></span>
              <span><b>{effect ? `LEVEL ${effect.intensity}` : 'CLEAR'}</b><small>{effect ? 'Travel directions are unreliable' : 'Travel brain currently functional'}</small></span>
            </div>
            {effect && <div className="rob-effect-note"><strong>TEMPORARY EFFECT</strong><p>{effect.message || 'Travel may go somewhere completely different for a while.'}</p></div>}
          </section>
          <section className="rob-choices">
            {!active ? (
              <RobButton disabled={busy} onClick={actions.robSmoke} detail="Rob packs the first bowl. Travel gets temporarily weird." tone="smoke">Smoke with Rob</RobButton>
            ) : (
              <>
                <RobButton disabled={busy} onClick={actions.robBongRip} detail={rob.giftedToday ? 'More smoke · stronger temporary travel confusion' : `More smoke · gift odds rise from here (${giftChance}% now)`} tone="smoke">Do another bong rip</RobButton>
                <RobButton disabled={busy} onClick={actions.robEndSession} detail="Hand the bong back. Any temporary stoned travel effect still has to wear off." tone="rest">Call it a day</RobButton>
              </>
            )}
            <RobButton disabled={busy} onClick={() => actions.travel('trailer_park')} detail="Head back into Mt. Gate. Normal local travel rules apply." tone="leave">Leave Rob's Trailer</RobButton>
            <RobButton disabled={busy} onClick={() => actions.travel('home')} detail="Career safety route: always FREE and SAFE." tone="home">Head Home — FREE &amp; SAFE</RobButton>
            <p className="rob-footnote">Rob's weed gift is limited to once per game day. Getting extremely high is not, apparently, subject to the same regulation.</p>
          </section>
        </div>
        {busy && <div className="rob-busy">ROB IS PASSING SOMETHING THAT SHOULD PROBABLY COME WITH GPS…</div>}
      </div>
    </div>
  );
}
